import {gsap} from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

window['gsap'] = gsap;

/**
 * Scroll to specific element using gsap
 *
 * @param element
 * @param offSet
 */
window['scrollToElement']  = (element = null, offSet = 0) => {
    if (element) {
        gsap.to(window, {
            duration: 0.6,
            scrollTo: element.offsetTop + offSet,
        });
    } else {
        gsap.to(window, {
            duration: 0.6,
            scrollTo: offSet,
        });
    }
}

/**
 * Toggle an element using gsap
 *
 * @param element
 * @param chevronElement
 */
window['toggleElement']  = (element, chevronElement = null) => {
    if (!element) {
        return;
    }

    const onOpened = () => {
        element.setAttribute('data-open', 1);

        if (chevronElement) {
            chevronElement.classList.remove('rotate-0');
            chevronElement.classList.add('rotate-180');
        }
    }

    const onClosed = () => {
        element.removeAttribute('data-open');

        if (chevronElement) {
            chevronElement.classList.remove('rotate-180');
            chevronElement.classList.add('rotate-0');
        }
    }

    if (element.getAttribute('data-open')) {
        gsap.fromTo((element), {
            height: 'auto'
        }, {
            duration: 0.15,
            height  : '0',
            ease    : 'none',
            onComplete() {
                onClosed()
            }
        });
    } else {
        gsap.fromTo((element), {
            height: '0'
        }, {
            duration: 0.15,
            height  : 'auto',
            ease    : 'none',
            onComplete() {
                onOpened()
            }
        });
    }
}
